import { isAllowedToWriteTags } from '@ion/api';

import { usePipelineTagsTableContext } from 'app/settings/tags-page/context/PipelineTagsTableContext';
import MODAL_OPTIONS from 'app/settings/tags-page/MODAL_OPTIONS';

export default function useRowsActionsProps(row) {
  const { onOpenModal } = usePipelineTagsTableContext();
  const canWrite = isAllowedToWriteTags();

  const onEdit = () => onOpenModal(MODAL_OPTIONS.editTag, row);
  const onDelete = () => onOpenModal(MODAL_OPTIONS.deleteTag, row);

  return {
    canWrite,
    onEdit,
    onDelete,
  };
}
